import React from 'react';
import './FounderMessage.css';

const PARAGRAPHS = [
  'I extend a heartfelt welcome to you on behalf of the entire CampusXL family.',
  'Our vision is to empower students through high-quality education, industry-relevant training, and transformative knowledge, while blending modern innovation with foundational learning. We strive to contribute towards building a progressive and inclusive society that fosters growth, embraces diversity, and enhances opportunities for the educated youth of our country.',
  'At CampusXL, we believe in shaping the future by nurturing talent and unlocking potential. We serve as a vital bridge between students, universities, and industry, ensuring a seamless integration of education with real-world opportunities.',
  'We are deeply committed to excellence and remain unwavering in our dedication to securing a strong and successful future for every student we engage with.',
];

const FounderMessage = () => (
  <section className="fmsg-root">
    <div className="fmsg-inner">

      {/* ── Left: portrait ── */}
      <div className="fmsg-portrait-col">
        <div className="fmsg-portrait-card">
          <img src="/team/puja.webp" alt="Puja Sharma" className="fmsg-photo" />
          <div className="fmsg-portrait-badge">
            <span className="fmsg-badge-name">Puja Sharma</span>
            <span className="fmsg-badge-role">Founder &amp; Director, CampusXL</span>
          </div>
        </div>
      </div>

      {/* ── Right: message ── */}
      <div className="fmsg-content">
        <span className="fmsg-eyebrow">Message from the Founder</span>
        <span className="fmsg-quote-mark" aria-hidden="true">&ldquo;</span>
        <div className="fmsg-paragraphs">
          {PARAGRAPHS.map((p, i) => (
            <p key={i} className={`fmsg-para${i === 0 ? ' fmsg-para--lead' : ''}`}>{p}</p>
          ))}
        </div>
        <div className="fmsg-signature">
          <div className="fmsg-sig-line" />
          <div>
            <p className="fmsg-sig-name">Puja Sharma</p>
            <p className="fmsg-sig-title">Founder &amp; Director</p>
          </div>
        </div>
      </div>

    </div>
  </section>
);

export default FounderMessage;
